import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './index.css';
import { CometChatConfig } from '@app/config';
import { UIKitSettingsBuilder } from '@cometchat/uikit-shared';
import { CometChatUIKit } from '@cometchat/chat-uikit-react';

console.log(import.meta.env.MODE, import.meta.env.VITE_API_URL);

/**
 * Initialize CometChat UIKit with the provided configuration
 */
const initializeCometChat = async () => {
  try {
    const uiKitSettings = new UIKitSettingsBuilder()
      .setAppId(CometChatConfig.APP_ID)
      .setRegion(CometChatConfig.REGION)
      .setAuthKey(CometChatConfig.AUTH_KEY)
      .subscribePresenceForAllUsers()
      .build();

    await CometChatUIKit.init(uiKitSettings);
    console.log('Chat SDK initialized.');
  } catch (error) {
    console.error('Error during CometChat initialization:', error);
  }
};

(async () => {
  await initializeCometChat(); // Ensure CometChat is initialized before rendering the app.

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
})();
